module.exports = __webpack_public_path__ + "img/0.4cee8c4c.jpg";